import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import Resumecontent from "./ResumeContent";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import pdf from "../../Assets/Rakad_Dwairi_Cv.pdf";

function Resume() {
  const uri = "https://porfolio-backend.vercel.app/ranks/getRanks";
  const [spojRank, upadteSpojRank] = useState(0);
  const [hackerrank, upadteHackerank] = useState(0);
  const [sem, upadateSem] = useState(0);
  const [cgpa, upadteCgpa] = useState(0);

  useEffect(() => {
    axios
      .get(uri)
      .then((res) => {
        upadteSpojRank(res.data.message[0].spojRank);
        upadteHackerank(res.data.message[1].hackerrank);
        upadteCgpa(res.data.message[2].cgpa);
        upadateSem(res.data.message[3].sem);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <Container fluid className="resume-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
            <i className="fas fa-download">&nbsp;</i>Download CV
          </Button>
        </Row>
        <Row className="resume">
          <Col md={6} className="resume-left">
            <h3 className="resume-title">Experience</h3>
            <h6>Merch by Amazon, Free Lancer </h6>
            <Resumecontent
              title="Graphic Designer"
              date="2018 – 2019"
              content={[
                "Developed design deliverables that elevated, differentiated and functioned on-brand and on-strategy.",
                "Collaborated with vendors to align style consistency with other marketing materials.",
                "Gathered and bought all materials needed to successfully complete projects.",
              ]}
            />
          <h6>Vision, Web Developer </h6>
          <Resumecontent
              title="Software Engineer"
              date="2018 – 2019"
              content={[
                "Discussed project progress with customers, collected feedback on different stages and directly addresses concerns.",
                "Prepared detailed reports on updates to project specification, progress, identified conflicts and team activities.",
                "Wrote highly maintainable, solid code, forming core framework and earning consistent praise from subsequent developers since initial version.",
              ]}
            />
          <h6>Web Designer, Computer Official </h6>
          <Resumecontent
              title="Software Engineer"
              date="2018 – 2019"
              content={[
                "Conceptualized, planned and executed original designs for wide range of website properties.",
                "Used and Contributed to style guides and other design documentation to maintain coherent information and interaction design patterns.",
                "Identified and eliminated website bugs to improve user experience.",
                "Created wireframes, screen-flow diagrams and UI spec documentation.",
              ]}
            />

        <h6>CEO, Jordan-Amman, InnovatoJo</h6>
          <Resumecontent
              title="Software Engineer"
              date="2020 – current"
              content={[
                "Developed coordinated and conducted complex tests and debugged systems.",
                "Worked with UX designers to design and build users interface and iterated based on user feedback.",
                "Specified requirements and supported software implementation, test case development verification test execution and certification.",
              ]}
            />

      <h6>CEO, Jordan-Amman, InnovatoJo</h6>
          <Resumecontent
              title="Lecturer"
              date="2021 – current"
              content={[
                "Used variety of learning modalities and support materials to facilitate learning process and accentuate presentations, including visual, aural and social learning modalities. ",
                "Evaluated and revised lesson plans and course content to facilitate and moderate classroom discussions and student-centered learning.",
                "Mentored undergraduate and graduate students in effective next steps for education and career preparedness.",
                "•	Delivered lectures of ",
              ]}
            />

      <h6>Software Engineer, Jordan-Amman, NCIT</h6>
          <Resumecontent
              title="Lecturer"
              date="2021 – current"
              content={[
                "Developed, maintained, and customized software application and tools using advanced development and coding techniques. Analyze code for system testing and debugging created test transactions to find, isolate and rectify issues.",
                "Specified requirements and supported software implementation, test case development verification test execution and certification.",
              ]}
            />

          </Col>
          <Col md={6} className="resume-right">
            <h3 className="resume-title">Education</h3>
            <h5>Jordan University of Science and Technology – Jordan – Irbid</h5>
            <Resumecontent
              title="Bachelor of Software Engineering "
              date="2018 - Present"
              content={[
                "GPA : 3.12 (Very Good)",
              ]}
            />
            {/* <Resumecontent
              title="12TH BOARD [ODM Public School,Odisha]"
              date="2015 - 2017"
              content={["Precentage: 88%"]}
            />
            <Resumecontent
              title="10TH BOARD [ST Mary's School,Odisha] "
              date="2005 - 2015"
              content={["Precentage: 86%"]}
            /> */}
            <h3 className="resume-title">Ranks and Achivements</h3>
            <Resumecontent
              title=""
              content={[
                "Member of Computergy Team.",
                "Elected Captain of Computergy Team, where I supervised a group of students to achieve goals that contribute to the growth of the organization.",
                
              ]}
            />
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
            <i className="fas fa-download">&nbsp;</i>Download CV
          </Button>
        </Row>
      </Container>
    </Container>
  );
}

export default Resume;
